import { useTonConnectUI } from '@tonconnect/ui-react';

import { type TONTransactionRequestDataType } from '../types/query/user';

export interface TonTransactionResponse {
  address: string;
  amount: number;
  payload: string;
  validUntil: string;
}

interface TransactionOptions {
  onSuccess?: () => void;
  onError?: () => void;
}

interface UseTonTransactionResult {
  sendTONTransaction: (
    transactionData: TONTransactionRequestDataType,
    options?: TransactionOptions,
  ) => Promise<void>;
}

const useTonTransaction = (): UseTonTransactionResult => {
  const [tonConnectUI] = useTonConnectUI();

  const sendTONTransaction = async (
    transactionData: TONTransactionRequestDataType,
    options?: TransactionOptions,
  ): Promise<void> => {
    try {
      const { address, amount, payload, validUntil } = transactionData;

      const validUntilTimestamp = Math.floor(
        new Date(validUntil).getTime() / 1000,
      );

      await tonConnectUI.sendTransaction({
        validUntil: validUntilTimestamp,
        messages: [
          {
            address,
            amount: amount.toString(),
            payload,
          },
        ],
      });

      options?.onSuccess?.();
    } catch (error) {
      console.error(error);
      options?.onError?.();
    }
  };

  return { sendTONTransaction };
};

export { useTonTransaction };
